import {
  ASSIGNMENT_CREATOR_BASE,
  BOOKSHELF_READER_REDIRECT_BASE,
  READER_BASE,
  REDIRECT_BASE,
} from '../../../api/redux-route/routes';
import { appendOrUpdateParams, getOrigin } from '../../../utils/route';
import {
  EDIT,
  NEW,
  VIEW,
} from 'app/ui/pages/redirect/AssignmentCreatorRedirect';

export function getInternalReaderUrl(isbn) {
  return `${READER_BASE}/${isbn}`;
}

export function getReaderUrlWithHost(isbn) {
  return getOrigin() + getInternalReaderUrl(isbn);
}

export function getRedirectUrl(destination, params = {}) {
  const url = `${REDIRECT_BASE}/${encodeURIComponent(destination)}`;
  return appendOrUpdateParams(url, params);
}

export function getBookshelfReaderRedirectUrl(url, vbid) {
  return `${BOOKSHELF_READER_REDIRECT_BASE}/${vbid}/${encodeURIComponent(url)}`;
}

export function getNewAssigmentUrl(vbid) {
  return `${ASSIGNMENT_CREATOR_BASE}/${NEW}/${vbid}`;
}

export function getEditAssignmentUrl(vbid, assignmentId) {
  return `${ASSIGNMENT_CREATOR_BASE}/${EDIT}/${vbid}/${assignmentId}`;
}

export function getViewAssignmentUrl(vbid, assignmentId) {
  return `${ASSIGNMENT_CREATOR_BASE}/${VIEW}/${vbid}/${assignmentId}`;
}

export function getBookshelfViewAssignmentUrl(base, vbid, assignmentId) {
  return `https:${base}/#/books/${vbid}/assignment/${assignmentId}`;
}



// WEBPACK FOOTER //
// ./src/app/ui/pages/shared/url-builder.js